import { render, staticRenderFns } from "./working-as-a-photographer.vue?vue&type=template&id=38a160ee&"
import script from "./working-as-a-photographer.vue?vue&type=script&lang=js&"
export * from "./working-as-a-photographer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports